export const isEmail = email => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export const isPhoneNumber = string => {
    if (string.length == 10) return true;
    return false;
}

export const onlyNumbers = string => {
    return string.replace(/\D/g, '');
}

export const onlyLettersAndWhitespace = string => {
    return string.replace(/\d/g, '').trim();
}

export const itemErrorDetails = (item, reqFields) => {
    let errorDetails = [];
    for (var i = 0; i < reqFields.length; i++) {

        if (reqFields[i] == 'phone' && item[reqFields[i]]) {

            if (!isPhoneNumber(item[reqFields[i]])) errorDetails.push([reqFields[i]]);

        } else if (reqFields[i] == 'email' && item[reqFields[i]]) {

            if (!isEmail(item[reqFields[i]])) errorDetails.push([reqFields[i]]);

        } else if (!item[`${reqFields[i]}`]) {

            console.log(`${reqFields[i]} not filled`);
            errorDetails.push([reqFields[i]]);

        }

    }

    return errorDetails;
}


// WEBPACK FOOTER //
// ./src/store/actions/formActions.jsx